import { Record } from "../../fable_modules/fable-library-js.4.25.0/Types.js";
import { record_type, bool_type, string_type, class_type } from "../../fable_modules/fable-library-js.4.25.0/Reflection.js";
import { Common_EmailAddress_$reflection } from "../../fable_modules/Webbler.Models.1.3.1/Api.fs.js";

export class Invitation extends Record {
    constructor(InvitationId, PatientName, PatientEmail, ReplyToEmail, PackageId, PracticeId, CreatedAt, Viewed) {
        super();
        this.InvitationId = InvitationId;
        this.PatientName = PatientName;
        this.PatientEmail = PatientEmail;
        this.ReplyToEmail = ReplyToEmail;
        this.PackageId = PackageId;
        this.PracticeId = PracticeId;
        this.CreatedAt = CreatedAt;
        this.Viewed = Viewed;
    }
}

export function Invitation_$reflection() {
    return record_type("ThreeDocs.Models.Domain.Invitation.Invitation", [], Invitation, () => [["InvitationId", class_type("System.Guid")], ["PatientName", string_type], ["PatientEmail", Common_EmailAddress_$reflection()], ["ReplyToEmail", Common_EmailAddress_$reflection()], ["PackageId", class_type("System.Guid")], ["PracticeId", class_type("System.Guid")], ["CreatedAt", class_type("System.DateTimeOffset")], ["Viewed", bool_type]]);
}

